import React, { createContext, useContext, useEffect, useState } from 'react';
import { getUserIsLoggendin, getUserLogin } from 'containers/User/service';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { fetchUserLanguagePreferences } from '../containers/Player/utils/languagePreferences';
import { getClaroAdsKey } from 'utils/claroAds/getClaroAdskey';

import useHandleUserProvider from 'context/hooks/useHandleUserProvider';
import ContentLoader from 'containers/Player/components/ContentLoader';
import { getLastTouchService } from 'api/services/user/lasttouch';
import {
  setProfileLastTouch,
  setProfileLastTouchFavorited,
} from 'utils/Socialization';
import { getUserToken } from 'utils/user/getUserToken';

const ERROR_CODE_TERMS_NOT_ACCEPTED = 'accept_terms';
const UserContext = createContext(null);
const UserConsumer = UserContext.Consumer;

const UserProvider = ({ children }) => {
  const claroLiteConfig = useSelector(state => getClaroAdsKey(state));
  const user = useSelector(state => state.user);
  const userToken = getUserToken()

  const {
    handleChangeProfile,
    loginApp,
    changeReady,
    userModel,
    checkUserLogin,
    logOutApp,
  } = useHandleUserProvider();

  useEffect(
    () => {
      if (user?.token && user?.userhash) {
        void fetchUserLanguagePreferences({ userToken: user.token });
      }
    },
    [JSON.stringify(user)],
  );

  useEffect(() => {
    sessionStorage.setItem('hasFetchNav', false)
    checkUserLogin(user => { });
    if (
      claroLiteConfig &&
      localStorage.getItem('logOutForce') === 'actived' &&
      !localStorage.getItem('loginInfo.logged_user') &&
      !localStorage.getItem('loginInfo.logged_user_data')
    )
      getUserIsLoggendin({ claroLiteConfig: claroLiteConfig });
  }, []);

  const updateLastTouch = async () => {
    const lasttouch = await getLastTouchService({user_token: getUserToken()});
    if (lasttouch?.data?.response?.lasttouch) {
      const lasttouchObj = lasttouch?.data?.response?.lasttouch;
      if (lasttouchObj.profile) setProfileLastTouch(lasttouchObj.profile);
      if (lasttouchObj.favorited)
        setProfileLastTouchFavorited(lasttouchObj.favorited);
      if (lasttouchObj.seen)
        localStorage.setItem('lasttouchSeen', lasttouchObj.seen);
    }
  };

  useEffect(
    () => {
      if (userToken && user?.userhash) {
        updateLastTouch();
      }
    },
    [userToken],
  );

  const getContext = () => ({
    userModel,
    changeProfile: handleChangeProfile,
    logout: logOutApp,
    login: loginApp,
    checkUserLogin,
  });
  if (!changeReady) return <ContentLoader />;
  return (
    <UserContext.Provider value={getContext()}>{children}</UserContext.Provider>
  );
};

UserProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export { UserContext, UserProvider, UserConsumer };
